// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"016b6b33","20":"6fa207a2","365":"1650873c","565":"e724ab9d","626":"645b99bc"}[chunkId] + ".chunk.js";
};